<ng-container *ngIf="_expanded">
  <div
    data-state="open"
    class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-transparent"
    data-aria-hidden="true"
    aria-hidden="true"
    style="pointer-events: auto"
  ></div>

  <div
    #dialogBox
    role="dialog"
    attr.data-state="{{ isOpen() }}"
    class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] data-[state=closed]:fade-out-50 data-[state=open]:fade-in-50 data-[state=closed]:zoom-out-90 data-[state=open]:zoom-in-90 data-[state=closed]:slide-out-to-top-[5%] data-[state=open]:slide-in-from-top-[5%] fixed left-[50%] z-50 grid h-4/5 w-4/5 translate-x-[-50%] translate-y-0 gap-4 border bg-white p-2 shadow-lg transition duration-1000 sm:rounded-lg lg:p-6"
    [ngClass]="{
      'top-4': !notify.show,
      'top-24': notify.show,
      'md:top-16': !notify.show,
      'md:top-36': notify.show
    }"
    style="pointer-events: auto"
    tabindex="-1"
  >
    <ng-content></ng-content>
  </div>
</ng-container>
